import React, { memo } from "react";
import styled from "styled-components/macro";
import TopSection from "./TopSection";
import BottomSection from "./BottomSection";
import { Container, defaultHorizontalMargin } from "theme/GlobalElements";

const MainHeader = () => {
  return (
    <Header id="header-main">
      <HeaderContainer>
        <Wrapper>
          <TopSection />
          <BottomSection />
        </Wrapper>
      </HeaderContainer>
    </Header>
  );
};
export default memo(MainHeader);

const Wrapper = styled.div`
  ${defaultHorizontalMargin};
`;
const HeaderContainer = styled(Container)`
  flex: 1;
  width: 100%;
`;

const Header = styled.div`
  width: 100%;
  background-image: url("/pattern-header.svg");
  background-attachment: fixed;
  background-size: cover;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
